import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchContent, type Catalog } from '../lib/content';

export function StandardsPage() {
  const [catalog, setCatalog] = useState<Catalog | null>(null);
  const [query, setQuery] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    document.title = 'Standards library · AstdZ';
    const controller = new AbortController();
    fetchContent<Catalog>('standards.json', controller.signal).then(setCatalog).catch((err: Error) => {
      if (!controller.signal.aborted) setError(err.message);
    });
    return () => controller.abort();
  }, []);
  const standards = catalog?.standards.filter((standard) => `${standard.code} ${standard.name}`.toLowerCase().includes(query.toLowerCase().trim())) ?? [];
  return <div className="docs-content standards-library">
    <div className="crumb">AstdZ / documentation / standards</div>
    <h1>One family. Eleven standards.</h1>
    <p>Specifications, wire layouts, and message libraries for structured data over mesh networks. An account is required to read and download the full standards.</p>
    <div className="content-notice"><strong>Implementation status</strong><p>The JavaScript reference codec and API support all eleven standards. The specifications remain draft, and the embedded C SDK currently supports EMRG only.</p></div>
    <div className="content-actions"><Link to="/docs/family-preamble">Read the family preamble →</Link><Link to="/docs/messages">Search all message libraries →</Link></div>
    <label className="content-search">Find a standard<input className="form-input" type="search" placeholder="Code or domain, such as water or EMRG" value={query} onChange={(event) => setQuery(event.target.value)} /></label>
    {error && <p role="alert">{error}</p>}
    {!catalog && !error && <p role="status">Loading standards…</p>}
    {catalog && <p className="text-muted" role="status">{standards.length} of {catalog.standards.length} standards</p>}
    <div className="standard-grid">{standards.map((standard) => <article className="standard-card" key={standard.code}>
      <div className="standard-card-top"><strong>{standard.code}</strong><span className={standard.implemented ? 'status-label active' : 'status-label'}>{standard.implemented ? 'Codec available' : 'Draft specification'}</span></div>
      <h2><Link to={`/docs/standards/${standard.slug}`}>{standard.name}</Link></h2>
      <p className="text-muted">Spec v{standard.version} · {standard.messageCount} messages · {standard.categoryCount} categories</p>
      {Boolean(standard.issues?.length) && <p className="warn">Specification review notes included</p>}
      <div className="content-actions"><Link to={`/docs/standards/${standard.slug}`}>Read specification →</Link><Link to={`/docs/messages?standard=${standard.code}`}>Messages →</Link></div>
      <Link className="download-link" to={`/docs/standards/${standard.slug}?download=1#download`}>Access download ↓</Link>
    </article>)}</div>
    {catalog && standards.length === 0 && <p>No standards match this search.</p>}
  </div>;
}
